module.exports = __webpack_public_path__ + "img/sent_w.54578cf9.png";